import React from "react";
import QuestionsList from "./QuestionsList.js";
import AddQuestion from "./AddQuestion";
// import "./index.css";
export default function Questions() {
    return (
        <div className=" ">
            <div className="">
                <QuestionsList />
            </div>
            {/* <div className="">
                <AddQuestion />
            </div> */}
        </div>
    );
}